import { displayNotification } from './snackbarUtils'


export const displayErrorMessage = (data, customMessage) => {
  const message = data?.message || data?.messages?.[0]?.msg || customMessage || 'An error occurred';
  displayNotification.error(message);
};
